import { createContext, useContext } from 'react';

type Props = {
  children: React.ReactNode;
  value: boolean;
};

const IsInButtonGroupContext = createContext<boolean>(false);

export function IsInButtonGroupProvider({ value, children }: Props) {
  return (
    <IsInButtonGroupContext.Provider value={value}>
      {children}
    </IsInButtonGroupContext.Provider>
  );
}

export function useIsInButtonGroup() {
  return useContext(IsInButtonGroupContext);
}
